import React from 'react';
import classes from './style.module.css'
import Aux from 'react-aux'

const WinnerBox = props => {

    let style = {
        backgroundColor: 'lightgreen'
    }

    if(props.type === "P") {
        style = {
            backgroundColor: 'lightblue'
        }
    }
     if(props.type === "L") {
        style = {
            backgroundColor: props.loserColor ? props.loserColor : 'lightcoral'
        }
    }
     if(props.type === "W") {
        style = {
            backgroundColor: props.winnerColor ? props.winnerColor : 'lightgreen'
        }
    }

    const tickBox = <div style={style} className={classes.WinnerBox}>
            {props.type}
    </div>

   return (
       <Aux>
       {tickBox}
       </Aux>
   );
}

export default WinnerBox;